import React from 'react';
import './Solution.css';

const solutionPoints = [
  { id: 5, content: 'Simple, not stupid - Powerful features without the complexity bloat', size: 'medium' },
  { id: 1, content: 'Save 70% on software costs', size: 'small' },
  { id: 2, content: 'Reclaim 5 hours per week', size: 'small' },
  { id: 3, content: 'Professional in minutes - Branded invoices and contracts instantly', size: 'medium' },
  { id: 4, content: 'Real insights, not chaos - Unified analytics across all business areas', size: 'large' },
  
];

function Solution() {
  return (
    <section id="solution" className="solution-section container ">
      <h3 className="solution-title fade-up">Everything You Need. Nothing You Don't.</h3>
      <p className="solution-text fade-up">
        Built specifically for new age entrepreneurs. BOSS replaces 10 tools with one unified platform that actually understands how you work.
      </p>
      <div className="solution-masonry fade-up">
        {solutionPoints.map(({ id, content, size }) => (
          <div
            key={id}
            className={`solution-card fade-up ${size}`}
          >
            <p>{content}</p>
          </div>
        ))}
      </div>
      <p className="supporting-statement fade-up">
        "No more learning curve nightmares. No more irrelevancy to your business. No more paying for enterprise features you'll never use. Just the tools service entrepreneurs actually need, working together seamlessly."
      </p>
    </section>
  );
}

export default Solution;
